// src/HomePage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';

const HomePage = () => {
  const navigate = useNavigate();

  const goToQuadratPreprocessing = () => {
    navigate('/prediction');
  };

  const goToTimeSeries = () => {
    navigate('/timeseries');
  };

  return (
    <div className="home-container">
      {/* HEADER SECTION */}
      <header className="header">
        <nav className="navbar">
          {/* Left side links */}
          <div className="navbar-left">
            <a href="#about">ABOUT</a>
            <a href="#challenge">CHALLENGE</a>
          </div>

          {/* Center title with red border */}
          <div className="title-container">
            <h1>PICOGRAM Data Viewer</h1>
          </div>

          {/* Right side links */}
          <div className="navbar-right">
            <a href="#publications">PUBLICATIONS</a>
            <a href="#team">TEAM</a>
          </div>
        </nav>
      </header>
      
      {/* SPONSORS SECTION */}
      <section className="sponsors">
        <h2>Our Collaborators</h2>
        <div className="sponsor-logos">
          {/* Replace these with actual sponsor logo paths or URLs */}
          <img src="/images/sponsor1.png" alt="Collaborator 1" className="sponsor-logo" />
          <img src="/images/sponsor2.png" alt="Collaborator 2" className="sponsor-logo" />
          <img src="/images/sponsor3.png" alt="Collaborator 3" className="sponsor-logo" />
        </div>
      </section>
      
      {/* ACTION BUTTONS */}
      <section className="actions">
        <button className="lightblue-button" onClick={goToQuadratPreprocessing}>
          Quadrat Preprocessing
        </button>
        <button className="lightblue-button" onClick={goToTimeSeries}>
          Time Series Analysis
        </button>
      </section>

      {/* DESCRIPTION SECTION */}
      <section className="description">
        <div className="tool-descriptions">
          <div className="tool-card">
            <h3>🔧 Quadrat Preprocessing</h3>
            <p>
              Professional tool for underwater image preprocessing. Upload large TIFF, JPEG, or PNG images, 
              apply color corrections optimized for underwater photography, and extract multiple quadrats 
              with preserved geolocation data.
            </p>
            <ul>
              <li>✅ Advanced TIFF/GeoTIFF support</li>
              <li>🌊 Underwater color correction presets</li>
              <li>📐 Multiple quadrat selection and processing</li>
              <li>🗺️ Geolocation preservation</li>
              <li>📁 Flexible export formats</li>
            </ul>
          </div>
          
          <div className="tool-card">
            <h3>📊 Time Series Analysis</h3>
            <p>
              Analyze coral growth and changes over time. Upload up to 16 time-point images, 
              track multiple coral objects, and visualize growth patterns with interactive charts.
            </p>
            <ul>
              <li>⏰ Multi-timepoint tracking (up to 16 images)</li>
              <li>🎯 Multiple coral object selection</li>
              <li>📈 Interactive growth visualization</li>
              <li>🤖 AI-powered segmentation (Picogram 1.0 & 2.0)</li>
              <li>📋 Comprehensive data export</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;